import React from 'react'
import { theme } from '@/config'
import { createStyles } from '@codeleap/styles'
import { useChatPreviewAvatar, useChatProps, useIsTablet } from '@/hooks'
import { GroupMembersList } from './GroupMembersList'
import { useChannelStateContext } from 'stream-chat-react'
import { Avatar, View, Text, UserDetailsModal, GroupDetailsModal, ActionIcon } from '@/components'

export const ChatHeader = ({ onBack }) => {
  const { channel, watcher_count } = useChannelStateContext()
  const previewAvatar = useChatPreviewAvatar({ channel })
  const { dmUser, displayTitle, isGroup } = useChatProps({ channel })

  const isTablet = useIsTablet()

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {isTablet && <ActionIcon
          debugName='ChatHeader:Back'
          icon='chevron-left'
          style={['large', 'minimal', 'normalize', styles.backButton]}
          onPress={onBack}
        />}

        <View
          onClick={() => isGroup ? GroupDetailsModal.open({ channel, initialPage: 'group_info' }) : UserDetailsModal.open({ user: dmUser?.user })}
          style={['gap:1', 'row']}
        >
          <Avatar
            debugName='ChatHeader:Avatar'
            image={previewAvatar as any}
            name={displayTitle}
            firstNameOnly={false}
            style={'chatHeader'}
          />

          <View style={['column', 'alignStart', 'justifyCenter']}>
            <Text style={['p2', { color: theme.colors.textHeadingHighlighted }]} text={displayTitle} />
            {isGroup ? <GroupMembersList /> : <ProfileRole dmUser={dmUser} isGroup={isGroup} watcher_count={watcher_count} />}
          </View>
        </View>
      </View>
    </View>
  )
}

const ProfileRole = ({ dmUser, isGroup, watcher_count }) => {

  const text = isGroup ? 'Online ' + String(watcher_count) : dmUser?.user?.job_title

  return (<Text style={['c2', { color: theme.colors.textCaption }]} text={text} />)
}

const styles = createStyles(theme => ({
  container: {
    ...theme.presets.row,
    ...theme.spacing.gap(2),
    ...theme.presets.fullWidth,
    ...theme.presets.alignCenter,
    justifyContent: 'space-between',
    ...theme.spacing.padding(3),
    backgroundColor: theme.baseColors.neutralSolid0,
    cursor: 'pointer',
  },
  content: {
    ...theme.presets.row,
    ...theme.spacing.gap(2),
    ...theme.presets.alignCenter,
    ...theme.presets.justifyStart,
    flex: 1,
    ...theme.presets.fullWidth,
  },
  backButton: {
    WebkitTapHighlightColor: 'transparent',
    '&:focus': {
      outline: 'none',
      backgroundColor: 'transparent',
    },
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&:focus-visible': {
      outline: 'none',
      backgroundColor: 'transparent',
    },
  },
}))
